import { render, staticRenderFns } from "./ModalSelectPrinter.vue?vue&type=template&id=b2d683f8&scoped=true"
import script from "./ModalSelectPrinter.vue?vue&type=script&lang=js"
export * from "./ModalSelectPrinter.vue?vue&type=script&lang=js"
import style0 from "./ModalSelectPrinter.vue?vue&type=style&index=0&id=b2d683f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2d683f8",
  null
  
)

export default component.exports